/**
 * TRCE Phase 2 — Apply runtime theme pack to document (L3 Dynamic UI).
 */
export type TrceRuntimeThemePack = {
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  fontFamily?: string;
  logoUrl?: string | null;
  faviconUrl?: string | null;
  cssVariables?: Record<string, string>;
};

export function applyTrceThemePack(pack: TrceRuntimeThemePack | null | undefined): void {
  if (!pack) return;
  const root = document.documentElement;

  const vars = pack.cssVariables ?? {};
  if (pack.primaryColor) vars["--runtime-primary"] = pack.primaryColor;
  if (pack.secondaryColor) vars["--runtime-secondary"] = pack.secondaryColor;
  if (pack.accentColor) vars["--runtime-accent"] = pack.accentColor;
  if (pack.fontFamily) vars["--runtime-font"] = pack.fontFamily;

  for (const [key, val] of Object.entries(vars)) {
    if (val) root.style.setProperty(key, val);
  }

  if (pack.primaryColor) {
    try {
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.setAttribute("content", pack.primaryColor);
    } catch { /* ignore */ }
  }

  if (pack.faviconUrl) {
    try {
      let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = pack.faviconUrl;
    } catch { /* ignore */ }
  }
}

export function clearTrceThemePack(): void {
  const root = document.documentElement;
  for (const key of ["--runtime-primary", "--runtime-secondary", "--runtime-accent", "--runtime-font"]) {
    root.style.removeProperty(key);
  }
}
